import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import ClientUserService from "../../../services/client-services/clientUserService";
import { serverConfig } from "../../../services/server-config";
import fallbackProfileLogo from '../../content-panes/admin-candidate/candiate-info-nav/img/avatar.png';
import { decodeJWT } from "../../../services/candidateService";
const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const fetchUserDetails = async () => {
            const decoded = decodeJWT(window.localStorage.getItem('authToken'));
            const username = _.get(decoded, 'username', '');
            if (!username) return;

            try {
                const response = await ClientUserService.getClientDetails(username);
                if (response?.data?.users?.length > 0) {
                    const userData = response.data.users[0];

                    setUser({
                        username: username,
                        name: userData.name || "Unknown User",
                        designation: userData.designation || "No Designation",
                        dpPath: userData.dpPath || fallbackProfileLogo,
                    });
                }
            } catch (error) {
                console.error("Error fetching user details:", error);
            }
        };

        fetchUserDetails();
    }, []);

    useEffect(() => {
        const fetchProfileImage = async () => {
            if (!user.dpPath || user.dpPath.startsWith("blob:")) return;

            try {
                const response = await axios.get(
                    `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${encodeURIComponent(user.dpPath)}`,
                    {
                        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
                        responseType: "blob",
                    }
                );

                const imageBlob = new Blob([response.data], { type: response.headers["content-type"] });
                const imageUrl = URL.createObjectURL(imageBlob);

                setUser((prevUser) => ({
                    ...prevUser,
                    imageBlobUrl: imageUrl,
                }));
            } catch (error) {
                console.error("Error fetching profile image:", error);
                setUser((prevUser) => ({
                    ...prevUser,
                    imageBlobUrl: fallbackProfileLogo,
                }));
            }
        };

        if (user?.dpPath) {
            fetchProfileImage();
        }
    }, [user?.dpPath]);

    return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
